import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

const Mcp = ({ data }) => {
  const [datum, setDatum] = useState({});

  useEffect(() => {
    if (data && data.length) {
      setDatum(data[0].attributes);
    }
  }, [data]);

  return (
    <>
      <div className="font-weight-bold text-secondary">MCP Name</div>
      <div>{datum.mcpName}</div>

      <div className="font-weight-bold text-secondary">Enrollment Date</div>
      <div>{format(datum.mcpEnrollmentDate, 'MM/DD/YYYY')}</div>
    </>
  );
};

Mcp.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    attributes: PropTypes.shape(),
  })).isRequired,
};

export default Mcp;
